import { atom } from "jotai";
import { ASSET_APP_IDS } from "@zapier/canvas-constants";

import { defaultNodesAtom } from "./defaultNodesAtom";

const isTablesNode = (appId: string = "") =>
  appId.includes(ASSET_APP_IDS.TABLES);

export const numberOfUniqueTableNodesAtom = atom((get) => {
  const nodes = get(defaultNodesAtom);

  const tableNodes = nodes.filter(
    (node) =>
      isTablesNode(node?.data?.services?.[0]?.currentImplementation.id) &&
      node.data.tableId,
  );

  // Get unique table IDs
  const uniqueTableIds = new Set(tableNodes.map((node) => node.data.tableId));

  return uniqueTableIds.size;
});

numberOfUniqueTableNodesAtom.debugLabel = "numberOfUniqueTableNodesAtom";
